import React, { FC } from 'react'

import { IconVPetProps } from './IconVPet.types'
import * as Styled from './styles/IconVPet.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVPet: FC<IconVPetProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVPetProps['size'],
  isResponsive = false,
}: IconVPetProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14.373 33.11c-.75-.658-1.568-.605-3.348-1.3a6.177 6.177 0 0 1-3-2.665c-3.362-5.823 1.423-10.96 6.53-9.645 2.058.532 3.692.465 4.582-.048a6.943 6.943 0 0 1 2.708-.92c3.158-.35 5.553 2.068 5.553 2.068s2.417 2.395 2.067 5.552a6.943 6.943 0 0 1-.92 2.708c-.513.89-.58 2.525-.048 4.582 1.318 5.108-3.82 9.893-9.642 6.523a6.178 6.178 0 0 1-2.665-3c-.695-1.78-.63-2.58-1.288-3.335l-.53-.52Zm23.38-11.605c1.38-1.38 1.588-3.408.465-4.53-1.123-1.124-3.151-.915-4.53.464-1.38 1.38-1.589 3.408-.466 4.531 1.123 1.123 3.151.915 4.531-.465Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M20.505 14.064c1.38-1.38 1.587-3.408.465-4.53-1.123-1.123-3.152-.915-4.531.464-1.38 1.38-1.588 3.408-.465 4.531 1.123 1.123 3.151.915 4.53-.465Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M38.055 31.811c1.38-1.38 1.588-3.408.465-4.53-1.123-1.123-3.151-.915-4.53.465-1.38 1.379-1.589 3.408-.466 4.53 1.123 1.123 3.151.915 4.53-.465Zm-7.742-17.499c1.38-1.38 1.588-3.408.465-4.531-1.123-1.123-3.151-.915-4.53.465-1.38 1.38-1.588 3.408-.466 4.53 1.123 1.123 3.152.915 4.531-.464Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVPet
